import { GridItemProps } from '../../../../Grid';

export const primarySectionProps: GridItemProps = {
  desktop: 4,
  tabletLandscape: 4,
};

export const secondarySectionProps: GridItemProps = {
  desktop: 3,
  tabletLandscape: 3,
};

export const fourColumnLayoutProps: GridItemProps = {
  desktop: 3,
  tabletLandscape: 3,
};
